import React from 'react';
import { useTranslation } from 'react-i18next';

export const PrivacyConsent = ({ agreed, setAgreed }) => {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  return (
    <label className="flex items-start gap-2 cursor-pointer" data-testid="privacy-consent">
      <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} className="mt-1 accent-red-600 flex-shrink-0" />
      <span className="text-xs text-gray-500 leading-relaxed">
        {isZh
          ? '您提交的信息仅用于业务沟通与服务跟进，我们将严格保护个人隐私，未经许可不会向第三方提供。请确保信息真实有效，以便我们为您提供准确服务。'
          : 'The information you provide will only be used for business communication and service follow-up. We protect your privacy in accordance with applicable laws and will not disclose your data to third parties without your consent.'}
      </span>
    </label>
  );
};

export const LoginConsent = ({ agreed, setAgreed }) => {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  return (
    <label className="flex items-start gap-2 cursor-pointer" data-testid="login-consent">
      <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} className="mt-1 accent-red-600 flex-shrink-0" />
      <span className="text-xs text-gray-500 leading-relaxed">
        {isZh
          ? '尊敬的用户，为完成账号登录与身份核验，系统将读取您的公开基础信息。您的个人信息将受到严格保护，仅在本次授权范围内使用，感谢您的理解与配合。'
          : 'For login and account security, we will access your public profile (nickname, avatar). Your information is protected and will only be used for identity verification.'}
      </span>
    </label>
  );
};
